<template>
    <HeaderBar></HeaderBar>
    <div class="smap_container" id="main_container">
        <MySitesBar></MySitesBar>
        <div class="smap_bar" id="menu_bar">
            <div v-for="f_item in tags" v-bind:key="f_item.id" class="tags_item">
                <div v-on:click="clickFirstTag(f_item.id,0)" :class="f_item.title_class">{{ f_item.name }}</div>
                <div class="tag_items" v-show="f_item.show_items">
                    <div v-for="(s_item) in f_item.items" v-bind:key="s_item.id" class="tag_item">
                        <span :class="s_item.class" v-on:click="clickItemTag(f_item.id,s_item.id,0,0)">
                            {{ s_item.name }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="smap_main" id="smap_main">
            <div v-for="f_item in links" v-bind:key="f_item.id" class="tag_links">
                <div class="links_title" :id="'c_'+f_item.id">{{ f_item.name }}</div>
                <div v-if="!f_item.tags || f_item.tags.length==0" class="link_items">
                    <div v-for="s_item in f_item.items" v-bind:key="s_item.id" class="link_item">
                        <a draggable="true" @dragstart="dragStart" :id="s_item.id" :name="s_item.icon" :href="s_item.url" target="_blank" v-on:click="clickSite(s_item.id)">
                            <div>
                                <img :src="!s_item.icon?'':s_item.icon"/>
                            </div>
                            <span>{{ s_item.name}}</span>
                        </a>
                    </div>
                </div>
                <div v-else-if="f_item.tags && f_item.tags.length>0">
                    <div v-for="s_item in f_item.tags" v-bind:key="s_item.id" class="sub_tag_links">
                        <div class="sub_links_title" :id="'t_'+s_item.id">{{ s_item.name }}</div>
                        <div class="link_items">
                            <div v-for="t_item in s_item.linkItems" v-bind:key="t_item.id" class="link_item">
                                <a draggable="true" @dragstart="dragStart" :id="t_item.id" :name="t_item.icon" :href="t_item.url" target="_blank" v-on:click="clickSite(t_item.id)">
                                    <div>
                                        <img :src="!t_item.icon?'':t_item.icon"/>
                                    </div>
                                    <span>{{ t_item.name}}</span>
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <FooterBar></FooterBar>
</template>

<script>
/* eslint-disable no-unused-vars */
import http from '../http.js';
import HeaderBar from '@/components/HeaderBar.vue';
import FooterBar from '@/components/FooterBar.vue';
import MySitesBar from '@/components/MySitesBar.vue';
    export default {
        name: 'SiteMap',
        components:{
            HeaderBar,
            FooterBar,
            MySitesBar
        },
        data(){
            return{
                leftPx:0,
                tags:[],
                links:[],
                tag_links:[]
            }
        },
        mounted(){
            this.getTags();
            this.setMenuBarLeft();
            window.addEventListener('resize', this.setMenuBarLeft);
        },
        methods:{
            dragStart(event){
                var target = event.target;
                console.log("event.target=",event.target)
                console.log("event.target.tagName=",event.target.tagName)
                if(event.target.tagName == "IMG"){
                    target = event.target.parentElement.parentElement;
                }
                if(target != undefined && target.tagName == "A"){
                    var url = target.href;
                    var name = target.text;
                    var id = target.id;
                    var icon = target.name;
                    const siteItem = { id:id, url:url,name:name,icon:icon };
                    event.dataTransfer.setData("text", JSON.stringify(siteItem));
                }
            },
            setMenuBarLeft(){
                let main_container = document.getElementById('main_container'); 
                if(main_container != undefined && main_container != null)
                    this.leftPx = main_container.offsetLeft;
                var menu_bar=document.getElementById('menu_bar');
                if(menu_bar != undefined && menu_bar != null)
                    menu_bar.style.left = this.leftPx + 'px';
            },
            getTags(){
                http.get('/getTags')
                .then(response => {
                    this.tags=response;
                    if(this.tags.length>0){
                        this.tags.forEach(item =>{
                            item.title_class="tag_title";
                            item.items.forEach(tag =>{
                                tag.class="tag_item_text";
                            });
                        });
                        var params = new URLSearchParams(window.location.search);
                        var q = params.get('q');
                        if(q != undefined && q != ""){
                            var p_array = q.split('_');
                            console.log("p_array",p_array)
                            var p_id = p_array[0];
                            var c_id = p_array[1];
                            var t_id = p_array[2];
                            var h_type = p_array[3];
                            if(p_id == 0){
                                var is_get_p_id = false;
                                for(var i=0;i<this.tags.length;i++){
                                    if(is_get_p_id){
                                        break;
                                    }
                                    for(var j=0;j<this.tags[i].items.length;j++){
                                        if(this.tags[i].items[j].id==c_id){
                                            p_id = this.tags[i].id;
                                            is_get_p_id = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            this.clickFirstTag(p_id,c_id,t_id,h_type);
                        }else{
                            this.clickFirstTag(this.tags[0].id,0,0,0);
                        }
                    }
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            getLinks(p_id,c_id,t_id,h_type){
                http.post('/getLinks',{"c_id":p_id})
                .then(response => {
                    this.links=response;
                    var tag_link = {"p_id":p_id,"links":this.links}
                    this.tag_links.push(tag_link);
                    this.clickItemTag(p_id,c_id>0?c_id:tag_link.links[0].id,t_id,h_type);
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
            clickFirstTag(p_id,c_id,t_id,h_type){
                var tag_exists = false;
                var set_links = false;
                this.tags.forEach((item,index) => {
                    if(item.id==p_id){
                        this.tags[index].show_items=!this.tags[index].show_items;
                        if(this.tags[index].show_items){
                            set_links = true;
                            item.title_class="tag_title_open";
                        }else{
                            item.title_class="tag_title";
                        }
                    }
                });
                this.tag_links.forEach((item) => {
                    if(item.p_id==p_id){
                        if(set_links){
                            this.links=item.links;
                            if(item.links.length>0){
                                this.clickItemTag(p_id,c_id>0?c_id:item.links[0].id,t_id,h_type);
                            }
                        }
                        tag_exists = true;
                    }
                });
                if(!tag_exists){
                    this.getLinks(p_id,c_id>0?c_id:0,t_id,h_type);
                }
            },
            clickItemTag(p_id,c_id,t_id,h_type){
                this.tag_links.forEach((item) => {
                    if(item.p_id==p_id){
                        this.links=item.links;
                        this.tagSelected(c_id);
                        var id = "c_"+c_id;
                        if(h_type==1){
                            id = "t_"+t_id;
                        }
                        setTimeout(()=>{
                            const section = document.getElementById(id);
                            if (section) {
                                window.scrollTo({
                                    top: section.offsetTop-20,
                                    behavior: 'smooth'
                                });
                            }
                        },10);
                        
                    }
                });
            },
            tagSelected(p_id){
                this.tags.forEach(item =>{
                    item.items.forEach(tag =>{
                        if(tag.id==p_id){
                            tag.class="tag_item_text_selected";
                        }else{
                            tag.class="tag_item_text";
                        }
                    });
                });
            },
            clickSite(id){
                http.post('/linkClick',{"id":id,"type":1})
                .then(response => {
                    
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
            },
        }
    }
</script>

<style scoped>
@import '../assets/styles.css';

.smap_container{  
    position: relative;
    display: flex;
    margin: 0px auto;
    width: 1280px;
    margin-top: 70px;
}

.smap_bar{
    position: fixed;
    left:0;
    top:70px;
    bottom: 0;
    z-index: 998;
    background-color: rgb(240, 241, 241);
    width: 240px;
    /* border-top:1px solid #DEE3EB;
    border-right:1px solid #DEE3EB; */
    border-radius:5px;
    padding: 5px;
    height: auto; /* 高度根据内容自适应 */
    box-sizing: border-box; /* 防止宽度计算错误 */
}
.smap_bar {
	overflow-y: scroll;
}
.smap_bar::-webkit-scrollbar {
    width: 4px;
}
.smap_bar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #2486b9;
}
.smap_bar::-webkit-scrollbar-track {
    border-radius: 0;
    background: white;
}

.tags_item{
    text-align: center;
}
.tag_title,.tag_title_open{
    background-color: #2486b9;
    border-radius:5px;
    color: rgb(231, 229, 229);
    font-size: 17px;
    margin-bottom: 1px;
    height: 32px;
    cursor: pointer;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE/Edge */
    user-select: none;         /* 标准语法 */
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如果也需要水平居中的话 */
}
.tag_title{
    background: url('../assets/close.png') no-repeat #2486b9;
    background-position: right 56px center;
    background-size:16px 16px;
}
.tag_title_open{
    background: url('../assets/open.png') no-repeat #2486b9;
    background-position: right 56px center;
    background-size:16px 16px;
}

.tag_items,.link_items{
    display: flex;
    flex-wrap: wrap;
}
.tag_items{
    padding: 10px 0px 0px 0px;
}
.tag_item{
    width: 70px;
    margin-bottom: 10px;
}

.tag_item_text,.tag_item_text_selected{
    padding: 3px 3px;
    color: #2486b9;
    font-size: 14px;
    cursor: pointer;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE/Edge */
    user-select: none;         /* 标准语法 */
}
.tag_item_text_selected{
    color:white;
    background-color: #2486b9;
    border-radius:3px;
}
.tag_item span:hover{
    color:white;
    background-color: #2486b9;
    border-radius:3px;
}

.smap_main{
    margin-left: 250px;
    margin-top: 70px;
    padding-right: 10px;
    min-height: calc(100vh - 62px);
}
.tag_links{
    margin-bottom: 30px;
    margin-left: 10px;
}

.sub_tag_links{
    margin-left: 10px;
}

.links_title{
    text-align: left;
    font-weight: bold;
    padding-bottom: 10px;
}

.sub_links_title{
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    color: #404040;
    padding-bottom: 10px;
    padding-left: 20px;
}

.link_items{
    display: flex;
    flex-flow:row wrap;
    margin-left: 20px;
}

.link_item{
    font-size: 14px;
    width: 140px;
    margin-bottom: 20px;
    margin-left: 20px;
}

.link_item a{
    display: flex;
    flex-direction: row;
}
.link_item a div{
    width: 16px;
    height: 16px;
    display: inline;
    margin:2px 3px 0px 0px;
}
.link_item a span{
    font-size: 14px;
}
.link_item a div img{
    width: 16px;
    height: 16px;
    vertical-align: top;
}
</style>